<template>
  <div>
    <div
      style="display: flex; text-align: center; border-bottom: 0.5px solid lightgrey; height: 30px; line-height: 30px">
      <div :style="{width: quick? 0 : '50%', 'border-right': (quick ? 0 : '0.5') + 'px solid lightgrey'}">钣金</div>
      <div :style="{width: quick? '100%' : '50%'}">喷漆</div>
    </div>
    <div style="display: flex; text-align: center">
      <div :style="{width: quick? 0 : '50%', 'border-right': (quick ? 0 : '0.5') + 'px solid lightgrey'}">

        <el-table :data="sheetMetalData" v-loading="loading" :height="tableHeight">
          <el-table-column align="center" label="定损部件" prop="name">
          </el-table-column>
          <el-table-column align="center" label="钣金工时" prop="sheetMetalWH" width="70">
            <template #default="{ row }">
              {{row.sheetMetalWH + row.disassemblyWH + row.assemblyWH}}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div :style="{width: quick? '100%' : '50%'}">

        <el-table :data="paintData" v-loading="loading" :height="tableHeight">
          <el-table-column align="center" label="定损部件" prop="name">
          </el-table-column>
          <el-table-column align="center" label="油漆幅数" prop="sheetMetalWH" width="70">
            <template #default="{ row }">
              {{row.paintArea}}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div style="margin-top: 20px; display: flex; justify-content: space-around">
      <div v-show="!quick">
        <label class="label" style="margin-right: 10px">维修钣件</label>
        <label v-loading="loading">
          <label v-if="!loading">{{work.lossDeterm.sheetMetalPiece}}</label>
        </label>
      </div>
      <div>
        <label class="label" style="margin-right: 10px">油漆幅数</label>
        <label v-loading="loading">
          <label v-if="!loading">{{work.lossDeterm.paintArea.toFixed(1)}}</label>
        </label>
      </div>
      <div v-show="!quick">
        <label class="label" style="margin-right: 10px">钣金工时</label>
        <label v-loading="loading">
          <label v-if="!loading">{{work.sheetMetalWH.toFixed(1)}}</label>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  import { resizeCaptureMixin } from '@/views/mixins/ResizeCapture'

  export default {
    name: 'WxLossDetermPanel',
    mixins: [resizeCaptureMixin],
    props: {
      work: Object
    },
    computed: {
      loading () {
        return !this.work.lossDeterm
      },
      sheetMetalData () {
        if (this.loading) return []
        return this.work.lossDeterm.partsList.filter(work => work.isSheetMetal || work.isDisassembly)
      },
      paintData () {
        if (this.loading) return []
        return this.work.lossDeterm.partsList.filter(work => work.isPaint)
      },
      quick () {
        if (this.loading) return false
        return this.work.lossDeterm.repairType === 'QUICK'
      },
      tableHeight () {
        return this.clientHeight - 260
      }
    }
  }
</script>

<style scoped>

</style>
